import { Component, ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent {
    window:any=<any>window;
    notification:any = {
        danger: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'danger'}}),
        success: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'success'}})
    };
    $:any=<any>this.window.$;
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });

    updateView:any = () => {
        this.zone.run(() => {
            this.populateAlerts();
            if(!this.queryparams()['type'] || !this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#alertModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteAlertModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['alert'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#alertModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#deleteAlertModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'create' && !this.queryparams()['alert'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteAlertModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#alertModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['alert'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteAlertModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#alertModal', element: this.elementref.nativeElement }});
            }
            this.populateAlerts();
            this.cd.detectChanges();
        });
    };

    filter_expanded:any = false;
    filter:any = {
        text: '',
        group: '',
        client: '',
        worker: '',
        from: 0,
        to: 0
    };
    datepicker_filter_from:any;
    datepicker_filter_to:any;
    collection_alert:any = [];
    alert:any = {configuration: {}};
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private elementref: ElementRef,
        private zone: NgZone
    ) {}

    ngAfterContentInit() {
        this.updateView();
        this.route.queryParams.subscribe((p:any) => this.updateView());
        this.window.bigBucket.element.addEventListener("connect", this.updateView.bind(this));
        this.window.bigBucket.element.addEventListener('change', this.updateView.bind(this));

        this.datepicker_filter_from = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            allow_empty: true,
            callback: (date) => {
                if(!date) return this.filter.from = 0;
                this.filter.from = date.getTime();
                this.populateAlerts();
            }
        });
        this.datepicker_filter_to = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            allow_empty: true,
            callback: (date) => {
                if(!date) return this.filter.to = 0;
                this.filter.to = date.getTime();
                this.populateAlerts();
            }
        });
    };

    ngOnDestroy() {
        this.window.bigBucket.element.addEventListener("connect", this.updateView.bind(this));
        this.window.bigBucket.element.addEventListener('change', this.updateView.bind(this));
    };

    populateAlerts = () => {
        this.collection_alert.length = 0;
        this.collection_alert.push(...(this.window.bigBucket.getBuckets()[this.window.appInfo.buckets.bigBucket.alert]?.objects?.sort((a:any, b:any) => {
            let a_timestamp = new Date(a.creation_timestamp).getTime(),
                b_timestamp = new Date(b.creation_timestamp).getTime();
            return a_timestamp > b_timestamp ? -1 : a_timestamp < b_timestamp ? 1 : 0;
        }).filter(alert => {
            if(!this.filter.text && 
                !this.filter.group && 
                !this.filter.client && 
                !this.filter.worker && 
                !this.filter.from && 
                !this.filter.to) return true;
    
            let filter_text = this.filter.text?.toLowerCase() || "",
                client = this.getUsers(alert.configuration?.client)[0] || {},
                worker = this.getUsers(alert.configuration?.owner)[0] || {},
                assegnazione = this.getAssegnazioni(alert.configuration?.assegnazione) || {},
                creation = new Date(alert.creation_timestamp).getTime();
            if(!!filter_text && 
                !client.public_configuration?.nome?.toLowerCase().includes(filter_text) &&
                !client.email?.toLowerCase().includes(filter_text) &&
                !worker.public_configuration?.nome?.toLowerCase().includes(filter_text) &&
                !worker.email?.toLowerCase().includes(filter_text) &&
                !assegnazione.configuration?.sede?.toLowerCase().includes(filter_text)) return false;
            if(!!this.filter.group && 
                !client.public_configuration?.groups?.find(e => e.id == this.filter.group) &&
                !worker.public_configuration?.groups?.find(e => e.id == this.filter.group)) return false;
            if(!!this.filter.client && 
                client.public_token != this.filter.client) return false;
            if(!!this.filter.worker && 
                worker.public_token != this.filter.worker) return false;
            if(!!this.filter.from &&
                creation < this.filter.from) return false;
            if(!!this.filter.to &&
                creation > this.filter.to) return false;
            return true;
        }) || []));
    };

    resetFilter = () => {
        this.filter = {
            text: '',
            group: '',
            client: '',
            worker: '',
            from: 0,
            to: 0
        };
        this.populateAlerts();
    };

    handleModal = (alert:any = undefined, type:any = undefined) => {
        this.router.navigate([`/alert`], { queryParams: this.changeQueryParam({ "alert" : alert, "type" : type }) });
    };

    get = (pt:any = false) => this.collection_alert?.filter(e => !pt || e.public_token == pt) || [];

    getAlert = () => {
        if(!!this.queryparams()['alert'] && this.queryparams()['type'] != 'create') return this.get(this.queryparams()['alert'])[0] || this.alert;
        return this.alert;
    };

    getAssegnazioni = (pt:any = false) => this.window.geoBucket.getBuckets()[this.window.appInfo.buckets.geoBucket.assegnazione]?.objects?.filter(e => !pt || e.public_token == pt) || [];

    getUsers = (pt:any = false, type:any = false) => [...this.window.usher.getChildren(), this.window.usher.get()]?.filter(user => (!pt || user.public_token == pt) && (!type || user.public_configuration?.type == type)) || [];

    getDescriptionAlert = (alert:any) => {
        let description = alert.configuration.tipo,
            anticipato = alert.configuration.anticipato,
            posticipato = alert.configuration.posticipato,
            fuori = alert.configuration.fuori_posizione,
            distanza_spaziale = alert.configuration.distanza_spaziale,
            distanza_temporale = `${this.window.flowup.utils.getTimeFromMinutes(alert.configuration.distanza_temporale)} ${alert.configuration.distanza_temporale >= 60 ? 'ore' : 'minuti'}`;
        if(!!anticipato || !!posticipato) {
            description += ` ${!!anticipato ? 'anticipata' : 'posticipata'} di ${distanza_temporale}`;
            if(!!fuori) description += ` e`;
        }
        if(!!fuori) description += ` fuori posizione di ${(distanza_spaziale/1000).toFixed(2)} km.`;
        return description;
    };

    getPosition = (alert:any) => {
        let geo = this.getAssegnazioni(alert.configuration?.assegnazione)[0]?.configuration?.geolocation_requested;
        if(!geo) return `Non richiesta`;
        let coordinates = alert.configuration.geometry?.coordinates;
        if(!coordinates?.length) return `Posizione non rilevata`;
        return `Richiesta - <a target="_blank" href="https://www.google.com/maps/place/${coordinates[0]},${coordinates[1]}">Vedi posizione</a>`;
    };

    deleteAlert = async () => {
        if(!this.getAlert().public_token) return this.handleModal(undefined, undefined);
        try {
            await this.getAlert().delete();
            this.handleModal(undefined, undefined);
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    downloadAlertCsv = async () => {
        const formatNow = this.window.moment().format("DD_MM_YYYY"),
            name = `Alert_${formatNow}.csv`;
        let csv_text = "Dipendente,Cliente,Sede,Data,Descrizione\r\n",
            formatted_collection = this.collection_alert.map(e => new Object({
                worker: this.getUsers(e.configuration?.owner)[0],
                client: this.getUsers(e.configuration?.client)[0],
                sede: this.getAssegnazioni(e.configuration?.assegnazione)?.configuration?.sede || "",
                data: this.window.flowup.utils.getDateTime(e.creation_timestamp),
                descrizione: this.getDescriptionAlert(e)
            }));

        if(!formatted_collection.length) return this.window.flowup.signal.emit({name: "notification", detail: { type: "danger", text: "Attenzione! Non ci sono alert scaricabili" }});
        
        formatted_collection.forEach(e => {
            csv_text += `${e.worker?.public_configuration?.nome},${e.client?.public_configuration?.nome},${e.sede || "Non rilevata"}`;
            csv_text += `,${e.data},${e.descrizione}\n`;
        });

        this.window.flowup.signal.emit({name: 'open-file', detail: {
            path: 'data:text/csv;charset=utf-8,' + encodeURI(csv_text),
            name: name
        }});
    };
}